import React from 'react';

export default function Instructions (props) {
    return (
        <section className='instructions'>
            <h1>Welcome to Pixar memory game</h1>
            <p>The rules are simple: only click each character once.</p>
            <p>The more you successfully click, the higher your score!</p>
        </section>
    )

}